// Image for small, square spots (avatars, nav items, table cells): the
// square icon, falling back to the wide logo when no icon is set. Headers
// with room for a wordmark use logo_url directly.
export function partnerIconUrl(p: { icon_url?: string | null; logo_url?: string | null }): string | null {
  return p.icon_url || p.logo_url || null;
}
